import React, { useContext, useEffect, useState } from "react";
import Header from "./ThemeHeaderNew";
// import Sidebar from "./ThemeSidebar";
import Sidebar from "./sidebar-new";
import useTheme from "../../hooks/useTheme";
import { SectionContenxt } from "../../context/CurrentSection";
import { CreatePage } from "../../context/CreateInvoice";
import { NavContext, NavProvider } from "../../context/NavToggle";
import { useLocation } from "react-router-dom";
import { allRoutes } from "../../assets/routes/allRoutes";
import { useTranslation } from "react-i18next";
import useRTLContext from "../../hooks/useRTLContext";
import { LazyLoader } from "../../assets/loaders";
const AuthFeature = (props) => {
  const { headerCollapse, mobileSidebar, miniSidebar, expandMenu } = useTheme();
  const [section, setSection] = useState("");
  const [createPage, setCreatePage] = useState("");
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t, i18n } = useTranslation();
  const [noAccess, setNoAccess] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const initializeLayout = async () => {
      try {
        setIsLoading(true);
        setError(null);

        // Simulate initialization delay for loading (you can replace with actual initialization logic)
        await new Promise((resolve) => setTimeout(resolve, 500));
      } catch (err) {
        console.error("Failed to initialize layout:", err);
        setError(err.message || "Failed to initialize application");
      } finally {
        setIsLoading(false);
      }
    };

    initializeLayout();
  }, []);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleCreatePage = (createPage) => {
    setCreatePage(createPage);
  };

  const createPageValue = {
    createPage: createPage,
    handleCreatePage: handleCreatePage,
  };

  const handleChangeSection = (section) => {
    setSection(section);
  };

  const value = {
    currentSection: section,
    handleChangeSection: handleChangeSection,
  };

  const handleNoAccess = (access) => {
    setNoAccess(access);
  };

  const LoadingState = () => <LazyLoader />;

  const ErrorState = () => (
    <div className="fixed inset-0 bg-white flex flex-col items-center justify-center p-4">
      <div className="bg-white px-6 py-6 rounded-xl flex flex-col items-center gap-4 border border-[#f2f4f7] max-w-md w-full">
        <div className="text-red-500">
          <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="text-center">
          <h3 className="font-bold text-[#04080b] text-lg mb-2">
            {t("Application Error")}
          </h3>
          <p className="text-[#475467] text-sm font-medium">
            {error || "Something went wrong while loading the application."}
          </p>
        </div>
        <button
          onClick={() => window.location.reload()}
          className="px-4 py-2 bg-white text-[#087a85] text-sm font-medium rounded-lg border border-[#f2f4f7] hover:bg-[#f9fafb] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#087a85] focus:ring-offset-2"
        >
          {t("Reload Page")}
        </button>
      </div>
    </div>
  );

  // Update your return statement to handle loading and error states
  if (isLoading) {
    return <LoadingState />;
  }

  if (error) {
    return <ErrorState />;
  }

  return (
    <NavProvider>
      <CreatePage.Provider value={createPageValue}>
        <SectionContenxt.Provider value={value}>
          {[allRoutes?.permittedModules, allRoutes?.changeNewPassword].includes(
            location?.pathname
          ) ? (
            props?.children
          ) : (
            <div
              className={`${isCollapsed ? "collapsed" : ""} ${
                noAccess ? "no-access" : ""
              }`}
            >
              {!noAccess ? (
                <Sidebar
                  toggleSidebar={toggleSidebar}
                  isCollapsed={isCollapsed}
                  handleNoAccess={handleNoAccess}
                />
              ) : null}
              <Header
                toggleSidebar={toggleSidebar}
                isCollapsed={isCollapsed}
                noAccess={noAccess}
              />
              {props.children}
            </div>
          )}
          <div className="sidebar-overlay"></div>
        </SectionContenxt.Provider>
      </CreatePage.Provider>
    </NavProvider>
  );
};

export default AuthFeature;
